import React from "react";
import Grid from "@material-ui/core/Grid";
import ContactMailIcon from "@material-ui/icons/Contacts";

import useStyles from "./style";

function Empty() {
  const classes = useStyles();
  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      justify="center"
      className={classes.empty}
    >
      <Grid item>
        <ContactMailIcon fontSize="large" />
      </Grid>
      <Grid item>No Contact Selected</Grid>
    </Grid>
  );
}

export default Empty;
